import { Component } from '@angular/core';

@Component({
  selector: 'gea-svg-shoe-width',
  templateUrl: './shoe-width.component.html',
  standalone: false
})
export class ShoeWidthComponent {

}
